import React, { useRef, useState, useEffect, useMemo } from 'react';
import { Chart as ChartJS, LineElement, PointElement, BarElement, CategoryScale, LinearScale, TimeScale, Title, LineController, BarController,Tooltip, Legend } from 'chart.js';
import { Line, Bar } from 'react-chartjs-2';
import { Chart } from 'react-chartjs-2';
import 'chartjs-adapter-date-fns';
import annotationPlugin from 'chartjs-plugin-annotation';
import * as Globals from './globals'; // Import everything from utils
import { format } from 'date-fns';



ChartJS.register(
  LineElement,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineController,
  BarController,
  Tooltip,
  Legend
);


ChartJS.register(LineElement, PointElement, BarElement, CategoryScale, LinearScale, TimeScale, Title, Tooltip, Legend, annotationPlugin);

const disablePlugins =false;
let isMouseOverChart = false;

let totalProfit = 0;
let totalReturn = 0;
let roundFinished = false;

let pulseCounter = 0;
let pulseIncrement = true;
const minOpacity = 0.0;  // Minimum transparency value
const maxOpacity = 0.9;  // Maximum transparency value
const pulseMaxCount = 20;
const pulseRadius = 20;

const responsiveFontSize = (Globals.baseFontSize + window.innerWidth * Globals.scalingFactor) + 'px';
const smallFont = (2 *  window.innerWidth ) + 'px';

const styles = {
  fontSize: responsiveFontSize,
  smallFontSize: smallFont,
  color: Globals.lightTextColor,
};


var fontBase = 1200;                     // default scren width

function getFont(fontSize,minFontSize, maxFontSize) {
  var ratio = fontSize / fontBase;   // calculate ratio
  var size = window.innerWidth * ratio;   // get font size based on current width
  
  // Ensure the size is within the specified range
  size = Math.max(minFontSize, Math.min(size, maxFontSize));

  return Math.floor(size) + 'px ' + Globals.fontFamily; // return font size and family
  }



const gradientOverlayPlugin = {
  id: 'gradientOverlayPlugin',
  afterDraw(chart) {
    if (disablePlugins) return;
    const { ctx, chartArea: { left, right, top, bottom }, scales: { x,y } } = chart;


    //DRAW GRADIENT TO LEFT OF GRAPH
    // Calculate the position of xAxisMin
    const xAxisMin = x.min;
    const xAxisMax = x.max;
    const yAxisMin = y.min;
    const yAxisMax = y.max;
    let xAxisMinPos = x.getPixelForValue(xAxisMin);
    let yAxisMinPos = y.getPixelForValue(yAxisMin);
    let yAxisMaxPos = y.getPixelForValue(yAxisMax );
    let yHeightGradient = Math.min (50,Math.abs(yAxisMaxPos-yAxisMinPos)/10)
    let yAxisGradientEnd = yAxisMaxPos+yHeightGradient;
    let yAxisGradientMid =  yAxisMaxPos+yHeightGradient/2;

    
    let xAxisMinPlusOneSecond = xAxisMin + 10000; // Add one second (1000 milliseconds)
    let xAxisMinPlusOneSecondPos = x.getPixelForValue(xAxisMinPlusOneSecond);
    
   
    /*
    // Create the gradient from left to xAxisMinPlusOneSecondPos
    const gradient = ctx.createLinearGradient(left, 0, xAxisMinPlusOneSecondPos, 0);

    // Set gradient stops
    let stop1 = (xAxisMinPos - left) / (xAxisMinPlusOneSecondPos - left);
    let stop2 = 1;
    
    gradient.addColorStop(0, 'rgba(25,31,45, 1)'); // Fully opaque color at start
    gradient.addColorStop(stop1, 'rgba(25,31,45, 1)'); // Fully opaque color at xAxisMin
    gradient.addColorStop(stop2, 'rgba(25,31,45, 0)'); // Fully transparent at xAxisMinPlusOneSecond

    
    ctx.save();
    ctx.fillStyle = gradient;
    ctx.fillRect(left, top, xAxisMinPlusOneSecondPos - left, bottom - top);
    ctx.restore();
*/
    //DRAWGRADIENT TO RIGHT OF GRAPH

    // Create the gradient from top to bottom


    // Create the gradient from left to xAxisMinPlusOneSecondPos
    const topGradient = ctx.createLinearGradient(left, top, left, yAxisGradientEnd);

    // Ensure yAxisGradientEnd and yAxisGradientMid are valid and top is not equal to yAxisGradientEnd
    if (top !== yAxisGradientEnd && !isNaN(top) && !isNaN(yAxisGradientEnd) && !isNaN(yAxisGradientMid)) {
        let stop1 = (yAxisGradientMid - top) / (yAxisGradientEnd - top);
        let stop2 = 1;

        // Ensure stop1 and stop2 are finite and within the range [0, 1]
        if (isFinite(stop1) && isFinite(stop2) && stop1 >= 0 && stop1 <= 1 && stop2 >= 0 && stop2 <= 1) {
            topGradient.addColorStop(0, 'rgba(25,31,45, 1)'); // Fully opaque color at start
            topGradient.addColorStop(stop1, 'rgba(25,31,45, 1)'); // Fully opaque color at xAxisMin
            topGradient.addColorStop(stop2, 'rgba(25,31,45, 0)'); // Fully transparent at xAxisMinPlusOneSecond
        } else {
            console.error("Invalid color stop values:", { stop1, stop2 });
        }
    } else {
        console.error("Invalid gradient calculation parameters:", { top, yAxisGradientEnd, yAxisGradientMid });
    }
     ctx.save();
     ctx.fillStyle = topGradient;
     ctx.fillRect(left, top, right-left,yAxisGradientEnd - top);
     ctx.restore();


  }
};

const customBoxPlotPlugin = {
  id: 'customBoxPlotPlugin',
  beforeDatasetsDraw(chart) {
    if (disablePlugins) return;
    const { ctx, chartArea: { left, right, top, bottom },scales: { x, y } } = chart;

    let latestBar = null;
    // Draw custom x-axis line at xAxisMin
    const xPos = x.getPixelForValue(chart.options.scales.x.min);
    const xAxisMinPixel = x.getPixelForValue(chart.options.scales.x.min);
    const xAxisMaxPixel = x.getPixelForValue(chart.options.scales.x.max);
    // Get x value of the last data position
   

    //DRAW A LINE A THE XAXISMIN POSIITON VERTICALLY
    /*
    ctx.beginPath();
    ctx.moveTo(xAxisMinPixel, y.getPixelForValue(y.min));
    ctx.lineTo(xAxisMinPixel, y.getPixelForValue(y.max));
    ctx.strokeStyle = 'rgba(255, 0, 255, 1)'; // Custom x-axis line color
    ctx.lineWidth = 5;
    ctx.stroke();
    */
    // Calculate the start time aligned to the nearest minute
    const startMs = Math.floor(x.min / 60000) * 60000;
    const endMs = x.max;

    //DRAW Y LINES EVERY 30 SECONDS
    for (let t = startMs; t <= endMs; t += 30_000) {
      if (t >= chart.options.scales.x.min && t <= chart.options.scales.x.max) 
      {
        const xPos = x.getPixelForValue(t);
    
        ctx.beginPath();
        ctx.moveTo(xPos, y.getPixelForValue(y.min));
        ctx.lineTo(xPos, y.getPixelForValue(y.max));
        ctx.strokeStyle = Globals.lightShadeColor; // Light color for tick lines
        ctx.lineWidth = 1;
        ctx.stroke();
      }
    }
    ctx.restore();
    chart.data.datasets.forEach((dataset) => {
      if (dataset.type === 'bar') {
         
          dataset.data.forEach((bar) => {
          const xStart = x.getPixelForValue(bar.xStart);
          const xEnd = x.getPixelForValue(bar.xEnd);
          
          const totalWidth = xEnd - xStart;
          const gapSize = totalWidth * 0.1; // 10% gap on each side
          const barWidth = totalWidth - gapSize * 2; // subtracting gap from both sides
          const newXStart = xStart + gapSize;
          const newXEnd = xEnd - gapSize;
          
          const yStartPixel = y.getPixelForValue(bar.yStart);
          const yEndPixel = y.getPixelForValue(bar.yEnd);
          const yMinPixel = y.getPixelForValue(bar.yMin);
          const yMaxPixel = y.getPixelForValue(bar.yMax);

          // Log for debugging
          //console.log(`Drawing bar - xStart: ${xStart}, xEnd: ${xEnd}, yStartPixel: ${yStartPixel}, yEndPixel: ${yEndPixel}, yMinPixel: ${yMinPixel}, yMaxPixel: ${yMaxPixel}`);
          const xCenter = (xStart + xEnd) / 2;
          // Draw min to max line
          ctx.beginPath();
          ctx.moveTo(xCenter, yMinPixel);
          ctx.lineTo(xCenter, yMaxPixel);
          ctx.strokeStyle = bar.backgroundColor;
          ctx.stroke();

          // Draw box from start to end
          ctx.fillStyle = bar.backgroundColor;
          ctx.fillRect(newXStart, yStartPixel, barWidth, yEndPixel - yStartPixel);

          // Keep track of the latest bar
          if (!latestBar || bar.xEnd > latestBar.xEnd) {
            latestBar = bar;
          }


        });

      }
    });
    chart.latestBar = latestBar;

    updatePulseCounter();
    

  }
};

const updatePulseCounter = () => {
  // Update pulseCounter
  if (pulseIncrement) {
    pulseCounter++;
    if (pulseCounter >= pulseMaxCount) {
      pulseIncrement = false;
    }
  } 
  else {
    pulseCounter--;
    if (pulseCounter <= 0) {
      pulseIncrement = true;
    }
  }
};



const drawGraphOverlaysPlugin = {
  id: 'drawGraphOverlaysPlugin',
  afterDraw: (chart) => {
    if (disablePlugins) return;
    const { ctx, chartArea: { top, bottom, left, right }, scales: { x, y } } = chart;
    const annotations = chart.options.plugins.annotation.annotations;
    const purchaseExpirationTimeRemaining = chart.options.gameRound.purchaseExpirationTimeRemaining;
    const expirationTimeRemaining = chart.options.gameRound.expirationTimeRemaining;
    const expirationTime = chart.options.gameRound.expirationTime;
    const inPlay = chart.options.gameRound.inPlay;
    const gamePhase = chart.options.gameRound.gamePhase;
    const bets = chart.options.gameRound.bets;
    const totalBetsAmount = chart.options.gameRound.totalBetsAmount;
    const latestBar = chart.latestBar;
    const finalDataPoint = chart.options.gameRound.finalDataPoint;
    const gameRound = chart.options.gameRound;
    const inGraph = chart.options.inGraph;
    const mousePosition = chart.options.mousePosition;
    const barsOn = chart.options.barsOn;
    

    //console.log ("FINAL DATA POINT:",finalDataPoint);
    const latestData = chart.data.datasets[0].data.slice(-1)[0];
    
    
    if (inGraph)
      displayTooltip(chart, mousePosition);



    if (annotations && annotations.purchaseExpirationTimeLine ) {
      const purchaseExpirationTimeValue = annotations.purchaseExpirationTimeLine.value;
      const xPos = x.getPixelForValue(purchaseExpirationTimeValue);

      const svgSize = 15; // Size of the SVG
      const svgSizeY = svgSize/0.85;  //icon is not square.
      const svgX = xPos - svgSize / 2; // Center the SVG horizontally
      const svgY = bottom- svgSize/2 ; // Position it at the bottom

      // Check if the SVG image is loaded
      if (Globals.SVGs.svgPurchaseExpiration.complete) {
        drawPurchaseLines(ctx,  top, bottom,svgX, svgY, svgSize,svgSizeY, purchaseExpirationTimeRemaining, inPlay, gamePhase);
      } else {
        // If the image is not loaded yet, set the onload event to draw it once loaded
        Globals.SVGs.svgPurchaseExpiration.onload = function() {
          drawPurchaseLines(ctx,  top, bottom,svgX, svgY, svgSize, svgSizeY,purchaseExpirationTimeRemaining, inPlay, gamePhase);
        };
      }
    }

    if (annotations && annotations.expirationTimeLine ) {
      
      const expirationTimeValue = annotations.expirationTimeLine.value;
      const xPos = x.getPixelForValue(expirationTimeValue);

      const svgSize = 15; // Size of the SVG
      const svgSizeY = svgSize/0.85;  //icon is not square.
      const svgX = xPos - svgSize / 2; // Center the SVG horizontally
      const svgY = bottom - svgSize/2 ; // Position it at the bottom
      
      // Check if the SVG image is loaded
      if (Globals.SVGs.svgExpirationDark.complete && Globals.SVGs.svgExpirationLight.complete) {
        
        drawExpirationLines(ctx, top, bottom, svgX, svgY, svgSize,svgSizeY, expirationTimeRemaining, inPlay, gamePhase);
      } else {
        // If the image is not loaded yet, set the onload event to draw it once loaded
          Globals.SVGs.svgExpirationDark.complete.onload = function() {
          drawExpirationLines(ctx, top, bottom, svgX, svgY, svgSize, svgSizeY,expirationTimeRemaining, inPlay, gamePhase);
        };
      }
    }

    const svgSize = 9; // Size of the SVG
    const svgSizeY = svgSize;  //icon is not square.
    
    drawBetPoints(ctx, x,y,top, bottom, svgSize,svgSizeY, expirationTime, inPlay, gamePhase,bets,gameRound);
    drawInBetInfo(ctx, x,y,top, bottom, left, right, svgSize,svgSizeY, purchaseExpirationTimeRemaining, expirationTimeRemaining, inPlay, gamePhase,bets,totalBetsAmount,finalDataPoint,gameRound);
    drawCurrentPoint(ctx, x,y,top, bottom, left,right, latestBar, latestData, purchaseExpirationTimeRemaining, expirationTimeRemaining, inPlay, gamePhase, gameRound,barsOn);
    //console.log(latestData);

  },
};



const displayTooltip = (chart, mousePosition) => {
  const { ctx, chartArea: { left, right, top, bottom }, scales: { x, y } } = chart;
  const { x: xPosition, y: yPosition } = mousePosition;

  // Ensure the positions are defined and within the chart area
  if (xPosition !== null && yPosition !== null && xPosition >= left && xPosition <= right && yPosition >= top && yPosition <= bottom) {
    // Convert the pixel positions to data values
    const xValue = x.getValueForPixel(xPosition);
    const yValue = y.getValueForPixel(yPosition);

    ctx.save(); // Save the current state of the context
    ctx.strokeStyle = Globals.lightShadeColor;
    ctx.lineWidth = 1; // Set the line width

    // Draw vertical line
    ctx.beginPath();
    ctx.moveTo(xPosition, top);
    ctx.lineTo(xPosition, bottom);
    ctx.stroke();
    ctx.closePath();

    // Draw horizontal line
    ctx.beginPath();
    ctx.moveTo(left, yPosition);
    ctx.lineTo(right, yPosition);
    ctx.stroke();
    ctx.closePath();

    //y axis tooltip
    // Draw filled rectangle on the right-hand side of the graph
    let rectWidth = 80;
    let rectHeight = 25; // Adjust as needed
    let rectX = right - rectWidth;
    let rectY = yPosition - rectHeight / 2;

    ctx.fillStyle = Globals.lightShadeColor;
    ctx.fillRect(rectX, rectY, rectWidth, rectHeight);

    // Print the value of the current data bet point inside the rectangle
    ctx.fillStyle = 'white'; // Set text color to white
    ctx.font = `12px ${Globals.fontFamily}`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(yValue.toFixed(4), rectX + rectWidth / 2, rectY + rectHeight / 2);
  
    // Draw filled rectangle on the bottom of the graph
    //rectWidth = 60;
    //rectHeight = 25; // Adjust as needed
    rectX = xPosition - rectWidth / 2;
    rectY = bottom - rectHeight;

    ctx.fillStyle = Globals.lightShadeColor;
    ctx.fillRect(rectX, rectY, rectWidth, rectHeight);

    // Print the value of the bet point inside the rectangle
    ctx.fillStyle = 'white'; // Set text color to white
    ctx.font = `12px ${Globals.fontFamily}`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(new Date(xValue).toLocaleTimeString(), rectX + rectWidth / 2, rectY + rectHeight / 2);

    ctx.restore(); // Restore the previous state of the context
  }
};



ChartJS.register(customBoxPlotPlugin,gradientOverlayPlugin, drawGraphOverlaysPlugin);
const drawCurrentPoint = (ctx, x,y,top, bottom, left, right, latestBar, latestData, purchaseExpirationTimeRemaining,expirationTimeRemaining, inPlay, gamePhase, gameRound,barsOn) => {
  
  //THE CURRENT POINT
  // Draw circle at the latest bar's xCenter and yMaxPixel
  
  if (!ctx || !x || !y) {
    console.warn("Canvas context or axes are undefined.");
    return;
  }

  // Ensure latestData exists and has valid properties
  if (!latestData || typeof latestData.x === 'undefined' || typeof latestData.y === 'undefined') {
    console.warn("Invalid latestData provided.");
    return;
  }
  
  if (gamePhase<3)
  {

    let currentX = x.getPixelForValue(latestData.x);
    const currentY = y.getPixelForValue(latestData.y);
    
    

    //keep updating the latest position with the pulsating current point
    if (latestBar && barsOn)
    {
      //console.log("latestBar:",latestBar);
      const xStart = x.getPixelForValue(latestBar.xStart);
      const xEnd = x.getPixelForValue(latestBar.xEnd);
      currentX = (xStart + xEnd) / 2;
      // Calculate latestData and currentY here
    }
    // Draw the line from xAxisMin to xAxisMax at the current data position
    //First half is dashed
    ctx.beginPath();
    ctx.setLineDash([7, 3]); // This makes the line dashed
    ctx.moveTo(left, currentY);
    ctx.lineTo(currentX, currentY);
    ctx.strokeStyle = Globals.lightShadeColor; // Replace 'linecolor' with the actual color value you want
    ctx.lineWidth = 1; // Adjust the line width if needed
    ctx.stroke();
    ctx.setLineDash([]); // Reset line dash to solid for future drawings
    //Second half is solid
    ctx.beginPath();
    ctx.moveTo(currentX, currentY);
    ctx.lineTo(right, currentY);
    ctx.strokeStyle = Globals.lightShadeColor; // Replace 'linecolor' with the actual color value you want
    ctx.lineWidth = 1; // Adjust the line width if needed
    ctx.stroke();

    //Current data point annotation
    // Draw block arrow pointing left with text
    const arrowWidth = 10;
    const arrowHeight = 30;
    const arrowX = right-80;
    const arrowY = currentY - arrowHeight / 2;
    const barY = arrowY + arrowHeight / 4;
    const barWidth = 80;
    const barHeight = arrowHeight/2;

    ctx.beginPath();
    ctx.moveTo(arrowX, arrowY);
    ctx.lineTo(arrowX - arrowWidth, arrowY + arrowHeight / 2);
    ctx.lineTo(arrowX, arrowY + arrowHeight);
    ctx.lineTo(arrowX+barWidth, arrowY + arrowHeight);
    ctx.lineTo(arrowX+barWidth, arrowY);
    ctx.closePath();
    ctx.fillStyle = 'rgba(255, 255, 255,.75)';
    ctx.fill();

    // Draw the text next to the arrow
    ctx.font = `12px ${Globals.fontFamily}`;
    ctx.fillStyle = 'black';
    ctx.textBaseline = 'middle'; // Align text vertically to the middle
    ctx.textAlign = 'center'; // Align text horizontally to the center
  
    ctx.fillText(latestData.y, arrowX +  barWidth/2 , arrowY + arrowHeight / 2 ); // Adjust the position as needed
    
    // Calculate transparency based on pulseCounter
    let transparency = minOpacity + (maxOpacity - minOpacity) * Math.abs(pulseCounter - pulseMaxCount / 2) / (pulseMaxCount / 2);
    ctx.beginPath();
    ctx.arc(currentX, currentY, 3, 0, 2 * Math.PI); // Adjust radius (3) as needed
    ctx.fillStyle =`rgb(0,200,155)`; // Adjust color as needed
    ctx.fill();
    ctx.save();
    
    // Set global alpha to 50% for overall transparency
    ctx.globalAlpha = transparency;

    // Create radial gradient using xCenter and currentY
    var radgrad = ctx.createRadialGradient(currentX, currentY, 0, currentX, currentY, 30);
    radgrad.addColorStop(0, 'rgba(0, 200, 155,1)');
    radgrad.addColorStop(0.1, 'rgba(0, 200, 155,0.9)');
    radgrad.addColorStop(0.5, 'rgba(0, 200, 155,0.1)');
    radgrad.addColorStop(1, 'rgba(0, 200, 155,0)');
    // Draw shape
    ctx.fillStyle = radgrad;
    ctx.fillRect(currentX - 75, currentY - 75, 150, 150);
    // Restore the context to its original state
    ctx.restore();

    //ctx.strokeStyle = 'black'; // Optional: outline the circle
    //ctx.stroke();
      

      
    }
    else{
      //show result
      const xPos = x.getPixelForValue(gameRound.expirationTime);
      const yPos = y.getPixelForValue(gameRound.finalDataPoint.v);

      // Draw the line from xAxisMin to xAxisMax at the current data position
      //First half is dashed
      ctx.beginPath();
      ctx.setLineDash([2, 2]); // This makes the line dashed
      ctx.moveTo(left, yPos);
      ctx.lineTo(xPos, yPos);
      ctx.strokeStyle = 'white'; // Replace 'linecolor' with the actual color value you want
      ctx.lineWidth = 2; // Adjust the line width if needed
      ctx.stroke();
      ctx.setLineDash([2,2]); // Reset line dash to solid for future drawings
      //Second half is faded
      ctx.beginPath();
      ctx.lineWidth = 1; // Adjust the line width if needed
      ctx.moveTo(xPos, yPos);
      ctx.lineTo(right, yPos);
      ctx.strokeStyle = Globals.lightShadeColor; // Replace 'linecolor' with the actual color value you want
      ctx.lineWidth = 1; // Adjust the line width if needed
      ctx.stroke();

      //Circle at final position
      ctx.beginPath();
      ctx.arc(xPos, yPos, 3, 0, 2 * Math.PI); // Adjust radius (3) as needed
      ctx.fillStyle = 'white'; 
      ctx.fill();

      // Draw block arrow pointing left with text
      let arrowWidth = 10;
      let arrowHeight = 30;
      let arrowX = right-80;
      let arrowY = yPos - arrowHeight / 2;
      let barY = arrowY + arrowHeight / 4;
      let barWidth = 80;
      let barHeight = arrowHeight/2;
  
      ctx.beginPath();
      ctx.moveTo(arrowX, arrowY);
      ctx.lineTo(arrowX - arrowWidth, arrowY + arrowHeight / 2);
      ctx.lineTo(arrowX, arrowY + arrowHeight);
      ctx.lineTo(arrowX+barWidth, arrowY + arrowHeight);
      ctx.lineTo(arrowX+barWidth, arrowY);
      ctx.closePath();
      ctx.fillStyle =`rgba(${Globals.rgbResultColor}, .9)`; ;
      
      ctx.fill();
  
      // Draw the text next to the arrow
      ctx.font = `12px ${Globals.fontFamily}`;
      ctx.fillStyle = 'white';
      ctx.textBaseline = 'middle'; // Align text vertically to the middle
      ctx.textAlign = 'center'; // Align text horizontally to the center
   
      ctx.fillText(gameRound.finalDataPoint.v, arrowX +  barWidth/2 , arrowY + arrowHeight / 2 ); // Adjust the position as needed
      

      // Draw result block arrow pointing left with text
       let arrowGap = 5;
       arrowWidth = 8;
       arrowHeight = 10;
       barWidth = 100;
       barHeight = 40;
       arrowX = xPos+arrowGap;
       arrowY = yPos ;
      
      ctx.beginPath();
      ctx.moveTo(arrowX, arrowY);
      ctx.lineTo(arrowX + arrowWidth, yPos - arrowHeight / 2);
      ctx.lineTo(arrowX + arrowWidth, yPos - barHeight/2);
      ctx.lineTo(arrowX+barWidth, yPos - barHeight/2);
      ctx.lineTo(arrowX+barWidth, yPos + barHeight/2);
      ctx.lineTo(arrowX+arrowWidth, yPos + barHeight/2);
      ctx.lineTo(arrowX + arrowWidth, yPos + arrowHeight / 2);
      ctx.closePath();
      ctx.fillStyle =`rgba(${Globals.rgbResultColor}, .9)`
      ctx.fill();

      // Draw the text next to the arrow
      /*
      ctx.font = `16px ${Globals.fontFamily}`;
      ctx.fillStyle = 'white';
      ctx.textBaseline = 'middle';
      ctx.textAlign = 'center'; 
     
      ctx.fillText(`${Globals.currencySymbol}${gameRound.totalReturn.toFixed(2)}`, arrowX +  arrowWidth + barWidth/2, yPos); 
      */
      const totalReturnX = arrowX + arrowWidth*2;
      const totalReturnY = yPos+7;
      const totalReturnLabelY = yPos - 7; // Adjust this value to position the label above the return value

      // Draw the label "TOTAL RETURN" above the return value
      ctx.font = `10px ${Globals.fontFamily}`;
      ctx.fillStyle = 'white';
      ctx.textBaseline = 'middle'; // Align text vertically to the middle
      ctx.textAlign = 'left'; // Align text horizontally to the center
      ctx.fillText("TOTAL RETURN", totalReturnX, totalReturnLabelY);

      // Draw the total return value
      ctx.font = `14px ${Globals.fontFamily}`;
      ctx.fillStyle = 'white';
      ctx.textBaseline = 'middle'; // Align text vertically to the middle
      ctx.textAlign = 'left'; // Align text horizontally to the center
      ctx.fillText(`${Globals.currencySymbol}${gameRound.totalReturn.toFixed(2)}`, totalReturnX, totalReturnY); // Adjust the position as needed

  
    }
}

/* ALL CHART PLUGINS HAVE BEEN REGISTERED */
const drawExpirationLines = (ctx, top, bottom, svgX, svgY, svgSize, svgSizeY,expirationTimeRemaining, inPlay, gamePhase) => {
   
//DISPLAY TIME REMAINING TEXT
      
  const circleRadius = 5+svgSizeY/2; // Radius is half of svgSize / 2
  //If gamePhase is 0,1 then show time remaining of puchase otherwise just the icon
  if (gamePhase<2){
    // EXPIRATION REMAINING Draw the filled circle
    ctx.beginPath();
    ctx.arc(svgX + svgSize / 2, svgY , circleRadius, 0, 2 * Math.PI); // Center the circle below the SVG
    ctx.fillStyle =  Globals.expirationColor; // Set the fill color using rgba
    ctx.fill();
    
    //DRAW THE CLOCK
    ctx.drawImage(Globals.SVGs.svgExpirationLight, svgX, svgY-svgSizeY/2, svgSize, svgSizeY);

  }
  else if (gamePhase==2)
    {
      //EXPIRATION REMAINING Draw circle showing time remaining
      ctx.beginPath();
      ctx.arc(svgX + svgSize / 2, svgY, circleRadius, 0, 2 * Math.PI);
      ctx.fillStyle = Globals.backColor; // Set the fill color to transparent
      ctx.fill();
      ctx.lineWidth = 2; // Set the border width
      ctx.strokeStyle = `rgba(${Globals.rgbExpirationColor}, .5)`; // Set the border color
      ctx.stroke();
     
      // Draw the arc corresponding to expirationTimeRemaining
      const endAngle = (Math.PI * 2 * expirationTimeRemaining) / 60; // Calculate the end angle for the arc
      ctx.beginPath();
      ctx.lineWidth = 2; 
      ctx.arc(svgX + svgSize / 2, svgY, circleRadius, -Math.PI / 2, -Math.PI / 2 + endAngle); // Adjust the arc start position
      ctx.strokeStyle =Globals.expirationColor; // Set the fill color for the arc
      ctx.stroke();

      // Ensure expirationTimeRemaining is always two digits
       const formattedExpirationTimeRemaining = expirationTimeRemaining.toString().padStart(2, '0');

      //DISPLAY TIME REMAINING TEXT
      ctx.font = `14px ${Globals.fontFamily}`;
      ctx.fillStyle = 'white'; // Set font color to white
      ctx.textBaseline = 'middle'; // Align text vertically to the middle
      ctx.textAlign = 'center'; // Align text horizontally to the center
      ctx.fillText(`:${formattedExpirationTimeRemaining}`, svgX + svgSize / 2, svgY); // Adjust text position as needed

    }
  else{
      // EXPIRATION FINISHED Draw the filled circle
      ctx.beginPath();
      ctx.arc(svgX + svgSize / 2, svgY , circleRadius, 0, 2 * Math.PI); // Center the circle below the SVG
      ctx.fillStyle = Globals.backColor; // Set the fill color
      ctx.fill();
      ctx.lineWidth = 1; // Set the border width
      ctx.strokeStyle = Globals.expirationColor; // Set the border color
      ctx.stroke();
      //DRAW THE CLOCK
      ctx.drawImage(Globals.SVGs.svgExpirationDark, svgX, svgY-svgSizeY/2, svgSize, svgSizeY);

    }
  }

const drawPurchaseLines = (ctx,top,bottom,svgX, svgY, svgSize, svgSizeY,purchaseExpirationTimeRemaining, inPlay, gamePhase) => {
    
    const circleRadius = 5+svgSizeY/2; // Radius is half of svgSize / 2
    
    //If gamePhase is 1 then show time remaining of puchase in the lower circle
    if (gamePhase==1)
    {
      //PURCHASE REMAINING Draw circle showing time remaining
      ctx.beginPath();
      ctx.arc(svgX + svgSize / 2, svgY, circleRadius, 0, 2 * Math.PI);
      ctx.fillStyle = Globals.backColor; // Set the fill color to transparent
      ctx.fill();
      ctx.lineWidth = 2; // Set the border width
      ctx.strokeStyle = Globals.lightShadeColor;//'rgba(Globals.lightShadeColor, 0.5)'; // Set the border color
      ctx.stroke();

      // Draw the arc corresponding to purchaseExpirationTimeRemaining
      const endAngle = (Math.PI * 2 * purchaseExpirationTimeRemaining) / 60; // Calculate the end angle for the arc
      ctx.beginPath();
      ctx.lineWidth = 2; 
      ctx.arc(svgX + svgSize / 2, svgY, circleRadius, -Math.PI / 2, -Math.PI / 2 + endAngle); // Adjust the arc start position
      ctx.strokeStyle ='white'; // Set the fill color for the arc
      ctx.stroke();

      // Ensure purchaseExpirationTimeRemaining is always two digits
      const formattedPurchaseExpirationTimeRemaining = purchaseExpirationTimeRemaining.toString().padStart(2, '0');

      //DISPLAY TIME REMAINING TEXT
      ctx.font = `14px ${Globals.fontFamily}`;
      ctx.fillStyle = 'white'; // Set font color to white
      ctx.textBaseline = 'middle'; // Align text vertically to the middle
      ctx.textAlign = 'center'; // Align text horizontally to the center
      ctx.fillText(`:${formattedPurchaseExpirationTimeRemaining}`, svgX + svgSize / 2, svgY); // Adjust text position as needed

    }
    else{
      // PURCHASE REMAINING Draw the filled circle
      ctx.beginPath();
      ctx.arc(svgX + svgSize / 2, svgY , circleRadius, 0, 2 * Math.PI); // Center the circle below the SVG
      ctx.fillStyle = 'white'; // Set the fill color
      ctx.fill();
    
      //DRAW THE CLOCK
      ctx.drawImage(Globals.SVGs.svgPurchaseExpiration, svgX, svgY-svgSizeY/2, svgSize, svgSizeY);
      if (!gamePhase)
        {
          //DISPLAY TIME REMAINING TEXT 
          // Draw "Expiration Time" text on two lines with font size 12
          ctx.font = `12px ${Globals.fontFamily}`;
          ctx.fillStyle = 'white';// Set font color to white
          ctx.textBaseline = 'middle'; // Align text vertically to the middle
          ctx.textAlign = 'right'; // Align text horizontally to the right
          // First line
          ctx.fillText("PURCHASE", svgX - 35, top + 12); // Adjust position as needed
          // Second line
          ctx.fillText("TIME", svgX - 35, top + 24); // Adjust position as needed

          // Ensure purchaseExpirationTimeRemaining is always two digits
          //const formattedPurchaseExpirationTimeRemaining = purchaseExpirationTimeRemaining.toString().padStart(2, '0');
          // Ensure purchaseExpirationTimeRemaining is always formatted as MM:SS
          const minutes = Math.floor(purchaseExpirationTimeRemaining / 60);
          const seconds = purchaseExpirationTimeRemaining % 60;
          const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
          
          ctx.font = `30px ${Globals.fontFamily}`;
          ctx.fillStyle = 'white'; 
          ctx.textBaseline = 'middle'; 
          ctx.textAlign = 'center'; 
          ctx.fillText(`${formattedTime}`, svgX + svgSize / 2, top+20); 


        }
    }
  };

const drawBetPoints = (ctx,x,y,top,bottom, svgSize, svgSizeY, expirationTime,inPlay, gamePhase,bets,gameRound) => {


  bets.forEach((bet, index) => {

    const isHigherBet = bet.betType.trim().toLowerCase() === "higher";

    const xPos = x.getPixelForValue(bet.timePlaced);
    const yPos = y.getPixelForValue(bet.entry.v);

    const xExpPos = x.getPixelForValue(expirationTime);

    // Calculate the SVG position based on the x and y positions
    const svgX = xPos - svgSize / 2;
    const svgY = yPos - svgSizeY / 2;

    // Determine the color based on the bet type
    let color = isHigherBet ? Globals.overColor : Globals.underColor;

    // Draw a horizontal dashed line from the bet point to the right-hand side of the graph
    ctx.strokeStyle = color;
    ctx.beginPath();
    ctx.lineWidth = 1; // Adjust the line width if needed
    ctx.setLineDash([5, 5]); // Set the line to be dashed
    ctx.moveTo(x.right, yPos);
    ctx.lineTo(x.left, yPos); // Draw to the right edge of the chart
    ctx.stroke();
    ctx.setLineDash([]); // Reset the line dash to solid for future drawings
    ctx.beginPath();
    ctx.moveTo(xPos, yPos);
    ctx.lineTo(xExpPos, yPos); // Draw to the right edge of the chart
    ctx.stroke();

    // Draw filled rectangle on the right-hand side of the graph
    let rectWidth = 80;
    let rectHeight = 25; // Adjust as needed
    let rectX = x.right - rectWidth;
    let rectY = yPos - rectHeight / 2;

    ctx.fillStyle = color;
    ctx.fillRect(rectX, rectY, rectWidth, rectHeight);

    // Print the value of the bet point inside the rectangle
    ctx.fillStyle = 'white'; // Set text color to white
    ctx.font = `10px ${Globals.fontFamily}`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(bet.entry.v, rectX + rectWidth / 2, rectY + rectHeight / 2);
  
    // Calculate the rectangle position (left and above the SVG)
    const rectPadding = -2; // Padding around the text inside the rectangle
    rectWidth = 40;
    rectHeight = 20; // Adjust as needed


    if (isHigherBet) {
        // Position above the SVG for higher bet
        rectX = svgX - rectWidth - rectPadding;
        rectY = svgY - rectHeight - rectPadding;
    } else {
        // Position below the SVG for lower bet
        rectX = svgX - rectWidth - rectPadding;
        rectY = svgY + rectPadding + svgSizeY;
    }


    // Determine the color based on the bet type
    color = isHigherBet ? `rgba(${Globals.rgbOverColor}, 0.9)` : `rgba(${Globals.rgbUnderColor}, 0.9)`;

    // Draw the rectangle with rounded corners
    ctx.fillStyle = color;
    ctx.beginPath();
    // Top-left corner
    ctx.moveTo(rectX + 10, rectY); // 10 is the radius of the curve
    // Top-right corner
    ctx.lineTo(rectX + rectWidth - 10, rectY);
    ctx.arcTo(rectX + rectWidth, rectY, rectX + rectWidth, rectY + 10, 10);
    // Bottom-right corner
    ctx.lineTo(rectX + rectWidth, rectY + rectHeight - 10);
    ctx.arcTo(rectX + rectWidth, rectY + rectHeight, rectX + rectWidth - 10, rectY + rectHeight, 10);
    // Bottom-left corner
    ctx.lineTo(rectX + 10, rectY + rectHeight);
    ctx.arcTo(rectX, rectY + rectHeight, rectX, rectY + rectHeight - 10, 10);
    // Top-left corner
    ctx.lineTo(rectX, rectY + 10);
    ctx.arcTo(rectX, rectY, rectX + 10, rectY, 10);
    ctx.closePath();
    ctx.fill();

    // Print the value of the bet amount inside the rectangle
    ctx.fillStyle = 'white'; // Set text color to white
    ctx.font = `10px ${Globals.fontFamily}`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(bet.amount, rectX + rectWidth / 2, rectY + rectHeight / 2);
  
    //console.log(`  Bet Type: ${bet.betType}`);
    if (bet.betType==="higher")
    {
      
    //if (bet.betType.trim().toLowerCase() === "higher") 
      if (Globals.SVGs.svgBetOver.complete && Globals.SVGs.svgBetOver.naturalHeight !== 0) {
        ctx.drawImage(Globals.SVGs.svgBetOver, svgX, svgY, svgSize, svgSizeY);
      }
      else{
        Globals.SVGs.svgBetOver.onload = () => {
          // Draw the image after it's loaded
          ctx.drawImage(Globals.SVGs.svgBetOver, svgX, svgY, svgSize, svgSizeY);
        };
      }

    }
    else
    {
      color = Globals.underColor
      ctx.drawImage(Globals.SVGs.svgBetUnder, svgX, svgY, svgSize, svgSizeY);
    }
    

    // Log bet details for debugging
    /*
    console.log(`Bet ${index + 1}:`);
    console.log(`  Time Placed: ${new Date(bet.timePlaced).toLocaleTimeString()}`);
    console.log(`  Bet Type: ${bet.betType}`);
    console.log(`  Amount: ${bet.amount}`);
    console.log(`  Result: ${bet.result}`);
    console.log(`  Data Point Noise Level: ${bet.entry.v}`);
    console.log(`  xPos: ${xPos}, yPos: ${yPos}, svgX: ${svgX}, svgY: ${svgY}`);
    */  
    // Draw the SVG at the calculated position
    
    //svgBetOverPathBase64
  });

}
      
const drawInBetInfo = (ctx,x,y,top,bottom, left, right, svgSize, svgSizeY,purchaseExpirationTimeRemaining, expirationTimeRemaining,inPlay, gamePhase,bets,totalBetsAmount,finalDataPoint, gameRound) => {

  
  if (gamePhase)
  { //print all the bet info at the top

    let screenWidth = window.innerWidth;
    let xPos;

    // Set xPos based on the screen width
    if (screenWidth < 768) {
      xPos = right - 310;
    } else {
      xPos = (left + right) / 2;
    }

    let yPos = top + 20;
    const svgX = xPos - svgSize / 2; // Center the SVG horizontally
    const svgY = top + svgSize/2 ; // Position it at the top
    
    // Measure the width of the text
    let textMetrics = "";
    let textWidth = 0;
    let text = "";
    let xPosNew = xPos;

    switch(gamePhase) {
      case 1: //CAN MAKE BETS 
        //DISPLAY TIME REMAINING TEXT 
        // Draw "Expiration Time" text on two lines with font size 12
        
        ctx.font = `10px ${Globals.fontFamily}`;
        ctx.fillStyle = 'white';
        ctx.textBaseline = 'middle'; 
        ctx.textAlign = 'left';
        // First line
        ctx.fillText("PURCHASE", xPos, top + 40); 
        // Second line
        ctx.fillText("TIME", xPos, top + 50); 

        // Ensure purchaseExpirationTimeRemaining is always two digits
        //const formattedPurchaseExpirationTimeRemaining = purchaseExpirationTimeRemaining.toString().padStart(2, '0');
        // Ensure purchaseExpirationTimeRemaining is always formatted as MM:SS
        const minutes = Math.floor(purchaseExpirationTimeRemaining / 60);
        const seconds = purchaseExpirationTimeRemaining % 60;
        const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        
        ctx.font = getFont(30,24,30); 
        ctx.fillStyle = 'white'; 
        ctx.textBaseline = 'middle'; 
        ctx.textAlign = 'left'; 
        ctx.fillText(`${formattedTime}`, xPos, top+20); 
        // Text to measure
        text = formattedTime;
        // Measure the width of the text
        textMetrics = ctx.measureText(text);
        xPosNew +=  textMetrics.width + 20;


      break;

      case 2: //WAITING FOR BET EXPIRATION
        //DISPLAY TIME REMAINING TEXT 
        // Draw "Expiration Time" text on two lines with font size 12
        
        ctx.font = `10px ${Globals.fontFamily}`;
        ctx.fillStyle = Globals.expirationColor;
        ctx.textBaseline = 'middle'; 
        ctx.textAlign = 'left';
        // First line
        ctx.fillText("EXPIRATION", xPos, top + 40); // Adjust position as needed
        // Second line
        ctx.fillText("TIME", xPos, top + 50); // Adjust position as needed

        // Ensure purchaseExpirationTimeRemaining is always two digits
        //const formattedPurchaseExpirationTimeRemaining = purchaseExpirationTimeRemaining.toString().padStart(2, '0');
        // Ensure purchaseExpirationTimeRemaining is always formatted as MM:SS
        const minutesE = Math.floor(expirationTimeRemaining / 60);
        const secondsE = expirationTimeRemaining % 60;
        const formattedTimeE = `${minutesE.toString().padStart(2, '0')}:${secondsE.toString().padStart(2, '0')}`;
        
        ctx.font = getFont(30,24,30); 
        ctx.fillStyle = Globals.expirationColor;; // Set font color to white
        ctx.textBaseline = 'middle'; // Align text vertically to the middle
        ctx.textAlign = 'left'; // Align text horizontally to the center
        ctx.fillText(`${formattedTimeE}`, xPos, top+20); // Adjust text position as needed
        // Text to measure
        text = formattedTimeE;
        // Measure the width of the text
        textMetrics = ctx.measureText(text);
        xPosNew +=  textMetrics.width + 20;

      break;

      case 3: //FINISHED BET
      
        break;
    }

    
    
    // Display Bet Info when gamePhase is 1 or 2
    if (gamePhase === 1 || gamePhase === 2) {

      ctx.font = `10px ${Globals.fontFamily}`;
      ctx.fillStyle = Globals.lightTextColor;// Set font color to white
      ctx.textBaseline = 'middle'; // Align text vertically to the middle
      ctx.textAlign = 'left'; // Align text horizontally to the right
      // First line
      ctx.fillText("TOTAL BET", xPosNew, top + 40); // Adjust position as needed
      
      ctx.font = getFont(30,24,30); 
      ctx.fillStyle = Globals.lightTextColor; // Set font color to white
      ctx.textBaseline = 'middle'; // Align text vertically to the middle
      ctx.textAlign = 'left'; // Align text horizontally to the center
      text = `${Globals.currencySymbol}${totalBetsAmount.toFixed(2)}`;
      ctx.fillText(text, xPosNew, top+20); // Adjust text position as needed
      // Measure the width of the text
      textMetrics = ctx.measureText(text);
      xPosNew +=  textMetrics.width + 20;

      // Calculate expected return
      const expectedProfit = gameRound.expectedProfit;
      
      
      ctx.font = `10px ${Globals.fontFamily}`;
      ctx.fillStyle = Globals.lightTextColor; // Set font color to white
      ctx.textBaseline = 'middle'; // Align text vertically to the middle
      ctx.textAlign = 'left'; // Align text horizontally to the right
      // Expected return text
      ctx.fillText("EXPECTED PROFIT", xPosNew, top + 40); // Adjust position as needed

      ctx.font = getFont(30,24,30); 
      ctx.fillStyle = expectedProfit >= 0 ? Globals.overColor : Globals.underColor; // Set font color based on expected return
      ctx.textBaseline = 'middle'; // Align text vertically to the middle
      ctx.textAlign = 'left'; // Align text horizontally to the center
      ctx.fillText(`${Globals.currencySymbol}${expectedProfit.toFixed(2)}`, xPosNew, top + 20); // Adjust text position as needed
    }

    
  }
}


const ChartOverlayComponent = ({
  data = [],
  barData = [],
  xAxisMin,
  xAxisMax,
  gameRound,
  inGraph,
  mousePosition,
  barsOn
}) => {
  const [yAxisMin, setYAxisMin] = useState(null);
  const [yAxisMax, setYAxisMax] = useState(null);

  // Always call hooks; never early-return before hooks.
  const visible = useMemo(() => {
    return (data || []).filter(d => d.t >= xAxisMin && d.t <= xAxisMax);
  }, [data, xAxisMin, xAxisMax]);
  
  const visibleBars = useMemo(() => {
    return barData.filter(b => b.xEnd >= xAxisMin && b.xStart <= xAxisMax);
  }, [barData, xAxisMin, xAxisMax]);

  useEffect(() => {
    if (!visible.length) {
      setYAxisMin(null);
      setYAxisMax(null);
      return;
    }
    
    const ys = visible.map(d => d.v).filter(Number.isFinite);
    if (!ys.length) {
      setYAxisMin(null);
      setYAxisMax(null);
      return;
    }
    const min = Math.min(...ys);
    const max = Math.max(...ys);

    // pad so line doesn't stick to edges; also avoids zero-range problems
    const pad = (max - min) * 0.05 || 1;

    setYAxisMin(min - pad);
    setYAxisMax(max + pad);
  }, [visible]);

  if (!visible.length) {
    return <div>Loading...</div>;
  }
  
  const chartData = {
    labels: visible.map(d => d.t),
    datasets: [
      {
        type: 'line',
        label: 'Value',
        data: visible.map(d => ({
          x: d.t,
          y: d.v
        })),
        fill: false,
        borderColor: 'rgba(255, 255, 255, .5)',
        tension: 0.1,
        pointRadius: 0,
        borderWidth: 1,
        order: 2,
      },
      ...(barsOn ? [{
        type: 'bar',
        label: 'Bars',
        data: visibleBars,
        backgroundColor: visibleBars.map(bar => bar.backgroundColor),
        order: 1,
      }] : [])
    ],
  };


  const annotations = {};

  if (
    gameRound.expirationTime &&
    yAxisMin !== null &&
    yAxisMax !== null
  ) {
    annotations.expirationTimeLine = {
      type: 'line',
      mode: 'vertical',
      scaleID: 'x',
      value: gameRound.expirationTime,
      borderColor: 'red',
      borderWidth: 2,
    };
  }

 
  if (
    gameRound.purchaseExpirationTime &&
    yAxisMin !== null &&
    yAxisMax !== null
  ) {
    annotations.purchaseExpirationTimeLine = {
      type: 'line',
      mode: 'vertical',
      scaleID: 'x',
      value: gameRound.purchaseExpirationTime,
      borderColor: 'white',
      borderWidth: 1,
      borderDash: [2, 2],
    };
  }


  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false, // Allows the chart to resize freely
    
    layout: {
      padding: 0
    },
    scales: {
      x: {
        type: 'time',
        time: {
          unit: 'minute',
          tooltipFormat: 'HH:mm:ss',
          displayFormats: {
            minute: 'HH:mm:ss'
          }
        },
        ticks: {
          stepSize: 1,
          source: 'auto',
          callback: function (value, index, values) {
            // Define a 20-second threshold
            const threshold = 25000; // 20 seconds in milliseconds

            // Convert xAxisMax to milliseconds
            const xAxisMaxAdjusted = xAxisMax - threshold;

            // Check if the value is within the range
            if (value < xAxisMin || value > xAxisMaxAdjusted) {
                return ''; // Hide tick if out of range
            }
            const date = new Date(value);
            return date.getSeconds() === 0 ? date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : '';
        
          },
          autoSkip: false, // Ensure all ticks are shown
          maxRotation: 0, // Prevent rotation
          labelOffset: -10, // Adjust label position to avoid clipping
          align: 'center',
        },
        min: xAxisMin, // Dynamic min value
        max: xAxisMax, // Dynamic max value
        offset: false,
        display: true,
        grid: {
          display: false // Disable grid lines
        },
        clip:0,
        bounds: 'data', // Ensure that the bounds are determined by the ticks
      },
      
      y: {
        beginAtZero: false,

        ...(yAxisMin !== null && yAxisMax !== null
          ? {
              min: yAxisMin,
              max: yAxisMax,
              ticks: {
                display: true,
                stepSize: (yAxisMax - yAxisMin) / 9,
                padding: 10,
              },
            }
          : {
              ticks: {
                display: true,
                padding: 10,
              },
            }),

        display: true,
        grid: {
          display: true,
          color: Globals.lightShadeColor,
        },
      },

    },
    
    animation: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
     
      annotation: {
        annotations: annotations
      },
      tooltip: {
        enabled:false,
      },

      gradientOverlayPlugin: true ,// Enable the gradient overlay plugin
      drawGraphOverlaysPlugin: true , // Enable the custom drawGraphOverlaysPlugin
    
    },
    gameRound,
    inGraph,
    mousePosition,
    barsOn,
  };

  return (
    <div className="chart-wrapper">
      <Bar data={chartData} options={chartOptions} />
    </div>
  );
};

export { ChartOverlayComponent };